import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGoogleBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGoogleBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9b1ace590eaf758b8f3699fb572aad5d8ff383dc', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '62aa6a976adaf38e41eccdba5511e10c428122cb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '96b9c4fd972dc2e103528bfdb2412276a894735e', d: "M19.822 11.205c0-.638-.058-1.252-.164-1.84h-8.477v3.485h4.844a4.15 4.15 0 0 1-1.808 2.708v2.267h2.92c1.703-1.571 2.685-3.878 2.685-6.62", fill: "#4285F4" }), h("path", { key: '19e0c7023476c4d46cf7062bdef9fc707f3851f2', d: "M11.18 20.002c2.43 0 4.469-.802 5.958-2.177l-2.921-2.267c-.802.54-1.825.868-3.036.868-2.34 0-4.329-1.58-5.04-3.707H3.144v2.324c1.481 2.938 4.517 4.959 8.036 4.959", fill: "#34A853" }), h("path", { key: '7f8c25106a952b4de9bcff28fe0dd49952a7c8af', d: "M6.14 12.71A5.4 5.4 0 0 1 5.854 11c0-.597.106-1.17.286-1.71V6.968H3.146A8.9 8.9 0 0 0 2.18 11a8.9 8.9 0 0 0 .966 4.034l2.332-1.817z", fill: "#FBBC05" }), h("path", { key: '45b6596d54df39770c2b6468b96acdc4e9093f7d', d: "M11.18 5.584c1.326 0 2.504.458 3.445 1.342l2.578-2.578C15.64 2.892 13.61 2 11.18 2 7.662 2 4.627 4.021 3.146 6.967L6.14 9.29c.712-2.128 2.7-3.707 5.04-3.707", fill: "#EA4335" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-google-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGoogleBranded$1);
            }
            break;
    } });
}

const CosmosIconGoogleBranded = CosmosIconGoogleBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGoogleBranded, defineCustomElement };
